import { eventsRequest } from '../../utils/eventsRequest';

/**
 * Payload for POST events/waivers (CreateEventWaiverDto).
 * JWT is sent via eventsRequest Authorization header.
 */
export interface CreateEventWaiverPayload {
  childId: number;
  clientSettingId: number;
  consentAccepted: boolean;
}

/**
 * Submits waiver acceptance (POST events/waivers).
 * Sends JWT via eventsRequest. clientSettingId is the eventSetting.id from the waiver item.
 */
const submitEventWaiver = async (
  payload: CreateEventWaiverPayload
): Promise<{ success: boolean; message?: string }> => {
  try {
    const response = await eventsRequest<{ statusCode: number; isSuccess: boolean }>(
      'events/waivers',
      'post',
      payload
    );

    if (response.status === 200 || response.status === 201) {
      const body = response.data;
      if (body?.isSuccess) {
        return { success: true };
      }
    }

    return { success: false, message: 'Failed to submit waiver' };
  } catch (error) {
    console.error('❌ Error submitting event waiver:', error);
    return { success: false, message: 'Unable to submit waiver. Please try again.' };
  }
};

export default submitEventWaiver;
